export { datepickerVariables as datepickerCalendarCellButtonVariables } from './datepickerVariables';
